__turbopack_context__.v({
  "body": "BoardSectionItemBoard-module-scss-module__9MenXq__body",
  "header": "BoardSectionItemBoard-module-scss-module__9MenXq__header",
  "isLargeWrapper": "BoardSectionItemBoard-module-scss-module__9MenXq__isLargeWrapper",
  "metaModules": "BoardSectionItemBoard-module-scss-module__9MenXq__metaModules",
  "title": "BoardSectionItemBoard-module-scss-module__9MenXq__title",
  "wrapper": "BoardSectionItemBoard-module-scss-module__9MenXq__wrapper",
});
